var React = require('react');

function ChevronSquareLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-95.51 325.57a24 24 0 0 1 0 33.95l-17 17a24 24 0 0 1-33.95 0L118.06 273a24 24 0 0 1 0-33.94l135.51-135.54a24 24 0 0 1 33.95 0l17 17a24 24 0 0 1 0 33.94L202.91 256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M118.06 239l135.51-135.48a24 24 0 0 1 33.95 0l17 17a24 24 0 0 1 0 33.94L202.91 256l101.58 101.57a24 24 0 0 1 0 33.95l-17 17a24 24 0 0 1-33.95 0L118.06 273a24 24 0 0 1 0-34z","className":"fa-primary","key":2})]);
}

ChevronSquareLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronSquareLeft;

ChevronSquareLeft.default = ChevronSquareLeft;
